module.exports = __webpack_public_path__ + "media/images/official/voice_quotation_start-0e75a7cf53e63fff6099470cdac7c67c.svg";